// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".skR3vVDlKuM73VhzR3LU3A\\=\\= {\n  display: flex;\n  flex-direction: column;\n}\n", "",{"version":3,"sources":["webpack://src/pages/usuarios/_styles.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF","sourcesContent":[".checkbox-vertical {\n  display: flex;\n  flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox-vertical": "skR3vVDlKuM73VhzR3LU3A=="
};
export default ___CSS_LOADER_EXPORT___;
